import axios from '../../services/api.service';

export const companyGetAll = async () => {
  try {
    const { data: response } = await axios.get('/review-1/companies');
    return {items: response.items, err: null};
  } catch (error) {
    return {res: null, err: error};
  }
};

export const companyPutOne = async (id: any, data: object) => {
  try {
    await axios.put(`/review-1/companies/${id}`, data);
    return {message: 'success', err: null};
  } catch (error) {
    return {res: null, err: error};
  }
};

export const customerDeleteOne = async (elementId: string) => {
  try {
    const { data: response } = await axios.delete(`/review-1/customers/${elementId}`);
    return 'success';
  } catch (error) {
    console.error(error)
    return 'error';
  }
};

export const companyGetOneBenefits = async (elementId: string) => {
  try {
    const { data: response } = await axios.get(`/review-1/companies/${elementId}/benefits`);
    return response.data.result;
  } catch (error) {
    console.error(error)
    return 'error';
  }
};

export const companyPutOneBenefits = async (elementId: string, data: object) => {
  try {
    const { data: response } = await axios.put(`/review-1/companies/${elementId}/benefits`, data);
    return 'success';
  } catch (error) {
    console.error(error)
    return 'error';
  }
};

export const companyGetOneBenchmarking = async (elementId: string) => {
  try {
    const { data: response } = await axios.get(`/review-1/companies/${elementId}/benchmarking`);
    return response.data.result;
  } catch (error) {
    console.error(error)
    return 'error';
  }
};

export const companyPutOneBenchmarking = async (elementId: string, data: object) => {
  try {
    const { data: response } = await axios.put(`/review-1/companies/${elementId}/benchmarking`, data);
    return 'success';
  } catch (error) {
    console.error(error)
    return 'error';
  }
};
